import {QueryFunctionContext} from 'react-query';
import request from '../../axios';

export const getStoreView = async (ctx: QueryFunctionContext) => {
  const params = ctx.queryKey[1];
  const {data}: {data: IDashboardActivity} = await request.get(
    `/api/v2/store/store-view?supplier=` + params,
  );
  return data;
};

export const getFarmCultivationView = async (ctx: QueryFunctionContext) => {
  const params = ctx.queryKey[1];
  const {data}: {data: Array<IDashboardCultivation>} = await request.get(
    `/api/v2/store/cultivation-report?supplier=` + params,
  );
  return data;
};
